import { render } from "./Template.vue?vue&type=template&id=cc2dab7a&scoped=true"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-cc2dab7a"

export default script